var H = require("hogan.js");
window.gettext || require("ehogan-loader/gt.js");
window.jscAdd || require("ehogan-loader/jscmanager.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<p class=\"paragraph paragraph__indent11\">");t.b(t.v( gettext("Используйте свои данные с других сервисов, чтобы создать аккаунт быстрее:") ));t.b("</p>");t.b("\n" + i);t.b("<p class=\"block-scl_waiting js-spin\">");t.b(t.v( gettext("Подключение к сервису...") ));t.b("</p>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<p class=\"paragraph paragraph__indent11\">{{ ___41___ }}</p>\n<p class=\"block-scl_waiting js-spin\">{{ ___167___ }}</p>\n", H);return T[arguments[0] instanceof Array ? "ri" : "render"].apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./registration/static_source/templates/registration/base/service_gettoken_message.html
// module id = 226
// module chunks = 7